<span [innerHTML]="data">

</span>
